export default "/images/vendor/flag-icons/flags/4x3/gn.svg?65edeaef7dabb0abc83498717b5f6ae1";